const mutationTypes = {
  SET_AUTH: 'setAuth',
  SET_IS_AUTHENTICATED: 'setIsAuthenticated'
};

const state = {
  auth: null,
  isAuthenticated: false
};

const mutations = {
  [mutationTypes.SET_AUTH]: (state, auth) => state.auth = auth,
  [mutationTypes.SET_IS_AUTHENTICATED]: (state, isAuthenticated) => state.isAuthenticated = isAuthenticated
};

const actions = {
  setAuth: ({commit}, auth) => {
    commit(mutationTypes.SET_AUTH, auth);
    commit(mutationTypes.SET_IS_AUTHENTICATED, !!auth);
  },
  removeAuth: ({commit}) => {
    commit(mutationTypes.SET_AUTH, null);
    commit(mutationTypes.SET_IS_AUTHENTICATED, false);
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};